export default __webpack_public_path__ + "svg/calendar/2026/5/junio.svg?eac33c9f";